export enum PageTitleEnum {
  ExceedersTitle = 'Exceeders | The World Premium IT Hub',
  StemexeTitle = 'StemeXe | Digital Transformation for Everyone'
}
